//theme is not supported in gantt chart hence not using theme object for styling.
const styles = {
  popupContainer: {
    zIndex: 1,
    margin: 0,
    padding: 2,
    minWidth: 32,
    boxSizing: "border-box",
    whiteSpace: "pre-line",
    background: "white",
  },
  additionalStopsRowContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 36,
    marginBottom: 4,
  },
  headerRowContainer: { width: 160 },
  violation: {
    color: "#FA5C64",
  },
  headerRowValue: {
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
    color: "#444444",
    lineHeight: 1,
    marginTop: 5,
    maxWidth:"none",
  },
  statusValue: {
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
    maxWidth:120
  },
  noViolation: {
    color: "#05A792",
  },
  multipleColumnRowContainer: {
    display: "flex",
    minWidth: 140,
  },
  rowContainerRight : {
    marginLeft : 8
  },
  headerLabel : {
    textTransform: "uppercase",
  }
};

export default styles;
